<template>
  <div :key="$store.getters['resource/currentResource'].key">

    <help :text="$t('help.emails')" :title="$t('help.emails_title')"/>

    <filters
      class="white-container"
      v-if="filters"
      :inputs="filters"
      @filter="filter"
      :extendButton="false"
      :extended="true"
      globalFilter="users.global"
      :loading="loading"
    >
    </filters>

    <div class="position-relative">

      <loader v-if="loading"/>

      <v-server-table
        ref="appTable"
        name="emailTable"
        class="white-container"
        url="/admin/mail-templates"
        :columns="columns"
        :options="options"
        @loaded="loading = false"
        @loading="loading = true">
        <template slot="beforeFilter">

          <b-row>
            <b-col>
              <router-link to="emails/create">
                <b-button
                  class="px-4 mb-3"
                >{{ $t('email_templates.add_new_email_template') }}
                </b-button>
              </router-link>
            </b-col>
          </b-row>
        </template>

        <template slot="id" slot-scope="props">
          <router-link :to="{path: `/emails/edit/${props.row.id}`, params: props.row}" target="_blank">
            {{ props.row.id }}
          </router-link>
        </template>

        <template slot="beforeLimit" v-if="totalRecordsCount > 10">
          {{$t('global.showing')}}&nbsp;
        </template>
        <template slot="afterLimit" v-if="totalRecordsCount > 10">
          &nbsp;{{$t('global.of_records_found', {number: totalRecordsCount})}}
        </template>
        <template slot="used" slot-scope="props">
          <column-check :row="props.row" column="used"/>
        </template>
        <template slot="created_at" slot-scope="props">
          <column-date :row="props.row" column="created_at" format="L"/>
        </template>
        <template slot="actions" slot-scope="props">
          <column-action
            :deleteUrl="`/mail-templates/${props.row.id}`"
            @deleteItems="refreshTable('appTable')"
            :route="{path: `/emails/edit/${props.row.id}`, params: {id: props.row.id}}"
          />
        </template>
      </v-server-table>
    </div>
  </div>

</template>

<script>
  import axios from '@/utils/axios';
  import {Event} from 'vue-tables-2';
  import emailsFilters from './emailsFilters.js';
  import filters from '@/components/global/filters';
  import i18n from "@/utils/i18n";

  export default {
    middleware: 'auth',
    name: 'Emails',
    components: {
      filters
    },
    data: () => {
      return {
        loading: false,
        totalRecordsCount: null,
        params: {
          page: 1,
          filter: {}
        },
        columns: ['id', 'name', 'subject', 'used', 'created_at', 'actions'],
        filters: emailsFilters,
        options: {
          skin: [],
          headings: {
            id: '#',
            name: i18n.t('form.name'),
            subject: i18n.t('form.subject'),
            used: i18n.t('form.used'),
            created_at: i18n.t('transactions.date_&_time'),
            actions: i18n.t('button.edit')
          },
          sortable: [],
          dateColumns: ['created_at'],
          columnsDropdown: false,
          filterByColumn: false,
          customFilters: ['custom'],
          perPage: !!localStorage.getItem('perPage') && localStorage.getItem('perPage') !== '' ? localStorage.getItem('perPage') : 10,
          filterable: false,
          requestFunction: function (data) {
            localStorage.setItem('perPage', data.limit);
            return axios.get(this.url, {
              params: {
                filter: data.custom,
                limit: data.limit,
                page: data.page
              }
            }).catch((e) => {
              // this.$noty.error(e.error_description);
              this.dispatch('error', e);
            });
          },
          responseAdapter: function (resp) {
            let data = this.getResponseData(resp);
            return {
              data: data.data.items,
              count: data.data.paginator.total_items
            }
          }
        },
      }
    },
    mounted() {
      Event.$on('vue-tables.emailTable.loaded', ({data}) => {
        this.totalRecordsCount = data.paginator.total_items
      });
    },
    methods: {
      filter(params) {
        this.params = params;
        Event.$emit('vue-tables.emailTable.filter::custom', params)
      }
    },
    destroyed() {
      Event.$off('vue-tables.emailTable.loaded');
    }
  }
</script>